import NamedDto from 'modules/base/dto/NamedDto';

export default class PiConnectionEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.apiUrl = null;
		/** @type {string} */
		this.username = null;
		/** @type {string} */
		this.password = null;
		/** @type {string} */
		this.serverId = null;
	}

	/**
	 * @typedef {Object} _PiConnectionEditDtoProps
	 * @property {string} apiUrl
	 * @property {string} username
	 * @property {string} password
	 * @property {string} serverId
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiConnectionEditDtoProps} PiConnectionEditDtoProps
	 */
	/**
	 * @param {PiConnectionEditDtoProps} props
	 * @returns {PiConnectionEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.apiUrl = props?.apiUrl;
		this.username = props?.username;
		this.password = props?.password;
		this.serverId = props?.serverId;
		return this;
	}
}
